import { Directive, EventEmitter, Output } from '@angular/core';
import { CDataConnectorSetting, CDataDBInfo } from '../../../../../../models/datamodel/adbinfo.model';

@Directive()
export abstract class ACDATAConnectorPanel {
    Settings: CDataConnectorSetting;
    DataSource: any;
    DBInfo: CDataDBInfo;

    @Output() OnDataChange = new EventEmitter<void>();
    onChange() {
        this.OnDataChange.emit();
    }
}
